import request from '@/utils/request'

// 회원사 리스트 조회
export function getClientMemberList(params, isNotify) {
  return request({
    url: `/api/getClientMemberList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 회원사 정보 저장
export function saveClientMemberData(params, isNotify) {
  return request({
    url: `/api/saveClientMemberData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 회원사 정보 삭제
export function deleteClientMemberData(params, isNotify) {
  return request({
    url: `/api/deleteClientMemberData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'deleted' }
  })
}